// @flow

import type {Node} from 'react';
import React, {useState} from 'react';

import { useSendVoucherGenerateEvent } from '@tectonics/analytics';
import { useEventBusListener } from '@tectonics/public-event-bus';
import { Ticket } from './ticket';
import { Separator } from '../../../../../atoms';
import { Tips } from './tips';
import { theme } from '../../../../../theme';


export function PixPageContent(): Node {
  const [isReady, setReady] = useState<bool>(false);

  useEventBusListener('bromelia:step:thank_you', () => {
    setReady(true);
  });

  useSendVoucherGenerateEvent(isReady);

  return (
    <div data-test-id="page-pending-payment" className="content-box content-box__row">
      <p style={Title}>Código Pix gerado!</p>
      <p style={Subtitle}>Falta pouco pra completar o seu pedido! Use os dados abaixo para pagar:</p>
      <Ticket />
      <Separator pattern="dashed" direction="vertical" size={5.5} />
      <Tips />
    </div>
  );
}

const Title = {
  fontSize: '22px',
  lineHeight: '26px',
  color: '#2397d4',
  fontFamily: theme.fontFamily.display,
  marginBottom: '10px',
};

const Subtitle = {
  fontSize: '14px',
  color: 'rgba(51, 51, 51, 0.8)',
  fontFamily: theme.fontFamily.display,
};
